<template>
  <transition name="collapse">
    <div
      v-show="isOpen"
      class="experiences-dropdown-menu"
    >
      <div class="inner container">
        <div
          v-for="category in categories"
          :key="category.id"
          class="experience-item"
          @click="goTo(category.slug)"
        >
          {{ category?.title }}
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import type { IApiResponse, ICategory } from "../../../types/general";
import customFetch from "../../../composables/customFetch";
import { useAsyncData, useRouter } from "nuxt/app";
import useCustomFetch from "../../../composables/useCustomFetch";

const { locale } = useI18n();

const router = useRouter();
const { categoryPath } = usePath();
const activeLocale = locale

const emit = defineEmits(["close"]);

const props = defineProps({
  isOpen: { type: Boolean, required: true, default: false },
});

watch(activeLocale, () => {
 updateCategoriesList()
});

const goTo = (slug: string) => {
  emit("close", false);
  router.push(categoryPath(slug));
};

const { data: categories } = await useAsyncData<ICategory[] | null>(
  "categories",
  () => customFetch(`api/categories`)
);

async function updateCategoriesList() {
  const { data, fetchData: updateCategories } = useCustomFetch(`/api/categories`);
  await updateCategories();
  const categoriesTmp: IApiResponse<ICategory[]> | null =
    data.value as IApiResponse<ICategory[]> | null;
    
  categories.value = categoriesTmp?.data ?? [];
}
</script>

<style scoped>
.experiences-dropdown-menu {
  @apply left-0 right-0 w-full overflow-y-auto lg:bg-gray-5 lg:shadow-1 
  relative lg:absolute z-50 top-full xs:max-lg:!px-0
}
.experiences-dropdown-menu .inner {
  @apply flex flex-wrap pt-2.5 lg:pb-4;
}
.experiences-dropdown-menu .inner .experience-item {
  @apply w-full sm:w-1/2 lg:w-1/4 my-2.5 lg:my-3 text-gray-1 lg:text-primary-1 hover:text-primary-2-hover text-heading-6 cursor-pointer;
}
.experiences-dropdown-menu::-webkit-scrollbar {
  @apply w-0 h-2 bg-transparent;
}
</style>
